import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ExportButtons({ api }) {
  const [busy, setBusy] = useState(null);
  const get = async (format) => {
    setBusy(format);
    try {
      const res = await api.get("/admin/revenue/export", { params: { format }, responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || `revenue.${format}`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      toast.error("Could not export. Try again.");
    } finally {
      setBusy(null);
    }
  };
  const cls = "min-h-[44px] px-4 border border-[#262626] hover:border-white font-mono-label text-[11px] inline-flex items-center gap-2 transition-colors disabled:opacity-50";
  return (
    <div className="flex gap-2">
      {["csv", "pdf"].map((f) => (
        <button key={f} onClick={() => get(f)} disabled={!!busy} className={cls} data-testid={`revenue-export-${f}`}>
          {busy === f ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} {f.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
